var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.preferences.author.agent_photo)?_c('img',{staticClass:"agent-photo",attrs:{"src":_vm.photoSrc,"alt":_vm.preferences.author.name}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }